import { jsx as _jsx } from "react/jsx-runtime";
import { FormErrorMessage as ChakraFormErrorMessage, } from '@chakra-ui/react';
/**
 * Used to provide feedback about an invalid input, and suggest clear instructions on how to fix it.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/formcontrol
 */
export function FormErrorMessage({ children, ...props }) {
    return _jsx(ChakraFormErrorMessage, { ...props, children: children });
}
//# sourceMappingURL=formerrormessage.js.map